export default __webpack_public_path__ + "static/media/token_collab.f3c39847.png";